import { useApp } from '../context/AppContext';
import { t } from '../data/translations';
import { Mail, Phone, MapPin } from 'lucide-react';
import SocialIcons from './SocialIcons';

export default function Footer() {
  const { lang, setPage } = useApp();
  const T = t[lang];

  return (
    <footer className="bg-gray-950 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img
              src="/logo-1762256791_-_Modifie.png"
              alt="LODISS"
              className="h-10 w-auto object-contain mb-4 brightness-200"
            />
            <p className="text-sm leading-relaxed text-gray-500">
              {lang === 'fr'
                ? 'Distributeur B2B d\'équipements de protection, vêtements pro et batteries industrielles & médicales.'
                : 'B2B distributor of protective equipment, professional workwear, and industrial & medical batteries.'}
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-widest">
              {T.nav.products}
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: lang === 'fr' ? 'Vêtements Pro' : 'Workwear', filter: 'vetements' },
                { label: lang === 'fr' ? 'EPI & Sécurité' : 'PPE & Safety', filter: 'epi' },
                { label: lang === 'fr' ? 'Batteries Pro' : 'Pro Batteries', filter: 'batteries' },
              ].map(item => (
                <li key={item.filter}>
                  <button
                    onClick={() => setPage('catalogue')}
                    className="hover:text-white transition-colors duration-150"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-widest">
              {lang === 'fr' ? 'Entreprise' : 'Company'}
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: T.nav.resellers, page: 'reseller' as const },
                { label: T.nav.services, page: 'services' as const },
                { label: T.nav.about, page: 'about' as const },
                { label: T.common.myOrders, page: 'orders' as const },
              ].map(item => (
                <li key={item.page}>
                  <button
                    onClick={() => setPage(item.page)}
                    className="hover:text-white transition-colors duration-150"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-widest">
              {T.nav.contact}
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 text-lodiss-red flex-shrink-0" />
                <span>{T.about.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 text-lodiss-red flex-shrink-0" />
                <span>{T.about.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-0.5 text-lodiss-red flex-shrink-0" />
                <span>{T.about.address}</span>
              </li>
            </ul>
            <div className="mt-4">
              <SocialIcons baseColor="#9ca3af" size={18} />
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-600">
          <p>© {new Date().getFullYear()} LODISS. {lang === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}</p>
          <p className="italic">
            {lang === 'fr' ? 'Votre sécurité est notre priorité' : 'Your safety is our priority'}
          </p>
        </div>
      </div>
    </footer>
  );
}
